export const en = {
    'Selected-of-regions': '{currentRegionCount} out of {totalRegionCount} cities selected',
    'all-city': 'All cities',
    'delete-screens': 'Remove screens',
    'many-screens': '{count} screens',
    'many-uncheck-confirm-message':
        'You are about to delete {count} screens in {city} from of the list of selected screens.',
    'one-screens': '{count} screen',
    'one-uncheck-confirm-message':
        'You are about to delete {count} screen in {city} from the list of selected screens.',
    'show-on-map': 'Show on map',
    'some-screens': '{count} screens',
    'some-uncheck-confirm-message':
        'You are about to delete {count} screens in {city} from the list of selected screens.'
};
